export interface DhChatProjectLike {
    connectors?: Array<unknown>
}

export type TariffVisibilityIds = {
    baseTariffId?: string | null
    currentTariffId?: string | null
}

const BLOCKING_TARIFF_IDS = new Set(['tariff2', 'tariff3'])
const DOCTOR_BOT_TARIFF_IDS = new Set(['tariff1'])

export function hasActiveMaxBusinessConnector(project?: DhChatProjectLike | null): boolean {
    return Boolean(
        project?.connectors?.some((connector) => {
            const rawConnector = connector as { providerType?: string; deleted?: boolean } | null
            const providerType = String(rawConnector?.providerType || '')
            const isDeleted = Boolean(rawConnector?.deleted)
            return !isDeleted && providerType === 'maxBusiness'
        }),
    )
}

function resolveTariffId({ baseTariffId, currentTariffId }: TariffVisibilityIds = {}): string {
    return String(baseTariffId || currentTariffId || '')
}

export function isBlockedBySmartBotTariff(ids: TariffVisibilityIds = {}): boolean {
    return BLOCKING_TARIFF_IDS.has(resolveTariffId(ids))
}

export function isBlockedByDoctorBotTariff(ids: TariffVisibilityIds = {}): boolean {
    return DOCTOR_BOT_TARIFF_IDS.has(resolveTariffId(ids))
}

export function projectHasYClientsConnector(project?: DhChatProjectLike | null): boolean {
    return Boolean(
        project?.connectors?.some(connector => {
            const connectorType = String(
                (connector as { connectorType?: string } | null)?.connectorType || '',
            )
            return connectorType === 'yClients'
        }),
    )
}

export function isDhChatBlockedByProjectState(options: {
    project?: DhChatProjectLike | null
} & TariffVisibilityIds): boolean {
    return (
        isBlockedBySmartBotTariff(options) ||
        hasActiveMaxBusinessConnector(options.project)
    )
}
